import { get, onAccountError, post } from '@/shared/utils/FetchV2.util';
import type {
	DeclaredDebt,
	OfferCartAnswer,
	OfferCartRequest,
	RegularizationOffer,
} from './types';

/**
 * The Regularización total routes of heru-sales-transaction-engine
 * (`/api/v1/heru-sales-transaction-engine/regularization`). The user is the
 * token's. Without `declared` the debt is measured against the SAT.
 */

const declaredParams = (declared?: DeclaredDebt) =>
	declared
		? `?years=${declared.years.join(',')}&regimes=${declared.regimes.join(',')}`
		: '';

/** `GET /offer`. A failure upstream still answers 200 with status `retry`. */
export const fetchRegularizationOffer = (declared?: DeclaredDebt) =>
	get<RegularizationOffer>({
		service: 'salesTransactionEngine',
		endpoint: `/regularization/offer${declaredParams(declared)}`,
	});

/**
 * `POST /cart`: the engine quotes again and builds the package cart at
 * `expectedChargeCents`. A 409 (the price changed, or the offer is no longer
 * sellable) and a 503 (retry) reject with the new offer in the body
 * (`offerOfCartError`). Only the 401 keeps the shared behavior (login).
 */
export const postRegularizationCart = async ({
	expectedChargeCents,
	declared,
	surface,
}: OfferCartRequest): Promise<OfferCartAnswer> => {
	try {
		return await post<OfferCartAnswer>({
			skipAccountError: true,
			service: 'salesTransactionEngine',
			endpoint: '/regularization/cart',
			body: {
				expected_charge_cents: expectedChargeCents,
				...(declared ? { years: declared.years, regimes: declared.regimes } : {}),
				...(surface ? { surface } : {}),
			},
		});
	} catch (error: any) {
		if (error?.response?.status === 401) onAccountError(error);
		throw error;
	}
};

/** The offer a refused `POST /cart` answers with, or null. */
export const offerOfCartError = (error: any): RegularizationOffer | null =>
	error?.response?.data?.offer ?? null;
